export default "__VITE_ASSET__CDNF_LTk__"